import { Pipe, PipeTransform } from '@angular/core';

import { Product, PromotionsModel } from '@bytel/bytel-sales';

@Pipe({
    name: 'priceInitial',
    pure: true,
    standalone: true,
})
export class PriceInitialPipe implements PipeTransform {
    transform(product: Product): number {
        let price: number = product.prices.base;

        price -= product.promotions.automatic
            .filter((promo) => promo.duration === 0)
            .reduce((acc, promotion) => acc + promotion.reductionAmount, 0);

        return Math.max(product.minPromoPrice, PromotionsModel.roundPrice(price));
    }
}
